import * as moment from 'moment';
import { config } from '../../config/config';
import { popupCenter } from '../common/extensions/browser/browser.extensions';
import { ConfigService } from './config.service';
import ShareDialogParams = facebook.ShareDialogParams;

export class ShareService {
  public static serverDomain = 'https://imgoingcalendar.com';

  public static toMailablePlace(hubName, item: any, url?: string): string {
    let description = item.description || item.about || '';
    description = description.replace(/(\n)+|(\r\n)+/g, ' ');
    let seg = description.split(' ');
    if (seg.length > 90) {
      seg = seg.slice(0, 90);
      description = seg.join(' ') + '...';
    }
    let category = item.category ? item.category.replace(/&/, 'and') : '';
    let name = item.name || item.title;
    name = name ? name.replace(/&/, 'and') : '';
    //item.description = description.replace(/&/, 'and');
    let address = (item.address.address || item.address).toString();
    address = address.replace(/&/, 'and');

    // if (url) {
    //     if (url.indexOf('/normal') === -1) {
    //         url += '/normal';
    //     }
    // }
    let link = url ? url : this.getPlaceUrl(hubName, item);

    let content = config.placeShare.mailTo
      .replace('${subject}', name)
      .replace('${body}', description)
      .replace('${category}', category)
      .replace('${address}', address)
      .replace('${url}', link);
    return content;
  }

  public static toMailableEvent(hubName, item: any, url?: string): string {
    let description = item.description || item.about || '';
    description = description.replace(/(\n)+|(\r\n)+/g, ' ');
    description = description.replace(/(&#39;)+/g, '');
    let seg = description.split(' ');
    if (seg.length > 90) {
      seg = seg.slice(0, 90);
      description = seg.join(' ') + '...';
    }

    let name = item.name || item.title;
    name = name ? name.replace(/&/, 'and') : '';
    let address = (item.address.address || item.address).toString();
    address = address.replace(/&/, 'and');

    let link = url ? url : this.getEventUrl(hubName, item);
    let startTime = moment(item.startTime).format(config.eventShare.mailDateFormat);
    let content = config.eventShare.mailTo
      .replace('${subject}', name)
      .replace('${body}', description)
      .replace('${startTime}', startTime)
      .replace('${owner}', item.owner.name)
      .replace('${url}', link);
    return content;
  }

  public static toMailableTrip(hubName, trpID, singleTripId?) {
    let content = config.tripShare.mailTo.replace('${url}', this.getTripLink(hubName, trpID, singleTripId));
    return content;
  }

  public static toMailableTour(hubName, tourID) {
    let content = config.tourShare.mailTo.replace('${url}', this.getTourLink(hubName, tourID));
    return content;
  }

  public static tweetTrip(hubName, wholeTripID, singleTripId?) {
    let shareLink = config.eventShare.tweet
      .replace('${text}', 'Check out my trip plan!')
      .replace('${url}', this.getTripLink(hubName, wholeTripID, singleTripId));
    popupCenter(shareLink);
  }

  public static tweetTour(hubName, tourID) {
    let shareLink = config.eventShare.tweet
      .replace('${text}', 'Check out this itinerary!')
      .replace('${url}', this.getTourLink(hubName, tourID));
    popupCenter(shareLink);
  }

  public static facebookShareTrip(hubName, trpID, singleTripId?) {
    window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' + this.getTripLink(hubName, trpID, singleTripId),
      'facebook-share-dialog',
      'width=800,height=600'
    );

    // let params = <ShareDialogParams>{
    //     method: 'share',
    //     quote: 'Check out my trip! ' + this.getTripLink(hubName, trpID, singleTripId),
    //     href: this.getTripLink(hubName, trpID, singleTripId),
    //     //picture: !!this.item.cover && this.item.cover.source
    // };
    // FB.ui(params, () => {
    // });
  }

  public static facebookShareTour(hubName, tourID) {
    window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' + this.getTourLink(hubName, tourID),
      'facebook-share-dialog',
      'width=800,height=600'
    );

    // let params = <ShareDialogParams>{
    //     method: 'share',
    //     quote: 'Check out this itinerary! ' + this.getTourLink(hubName, tourID),
    //     href: this.getTourLink(hubName, tourID),
    //     //picture: !!this.item.cover && this.item.cover.source
    // };
    // FB.ui(params, () => {
    // });
  }

  public static getEventUrl(hubName, item: any) {
    let url = ShareService.serverDomain;
    url = `${url}/${hubName}/events/${item._id}`;
    //url = url.substring(0, url.lastIndexOf('/')) + '/events/' + item._id;
    return url;
  }

  public static getPlaceUrl(hubName, item: any) {
    let url = ShareService.serverDomain;
    url = `${url}/${hubName}/place/${item._id}/all/normal`;
    //url = url.substring(0, url.lastIndexOf('/')) + '/place/' + item._id + '/all/normal';
    return url;
  }

  public static getTripLink(hubName, wholeTripID, singleTripId?) {
    let url = ShareService.serverDomain;
    if (!singleTripId) {
      url = `${url}/${hubName}/trips/${wholeTripID}`;
      //url = `${url.substr(0, url.indexOf('/trips'))}/trips/${wholeTripID}` ;
    } else {
      url = `${url}/${hubName}/trips/${wholeTripID}/${singleTripId}`;
      //url = `${url.substr(0, url.indexOf('/trips'))}/trips/${wholeTripID}/${singleTripId}`;
    }
    return url;
  }

  public static getTourLink(hubName, TourID) {
    let url = ShareService.serverDomain;
    url = `${url}/${hubName}/trips/tour/${TourID}`;
    //url = `${url.substr(0, url.indexOf('/trips'))}/trips/tour/${TourID}` ;
    return url;
  }

  public static getFacebookPlaceId(link: string) {
    if (!link || link.indexOf('https://www.facebook.com/') === -1) {
      return null;
    }

    let fbSeg = link.split('https://www.facebook.com/')[1];
    let id = null;
    let seg = fbSeg.split('/');
    if (seg[0] === 'pages') {
      id = seg[seg.length - 1];
      console.log('pages/' + id);
      if (id.indexOf('-') >= 0) {
        let dashSeg = id.split('-');
        id = dashSeg[dashSeg.length - 1];
      }
    } else if (seg[0].indexOf('-') >= 0) {
      let dashSeg = seg[0].split('-');
      id = dashSeg[dashSeg.length - 1];
      console.log(seg[0]);
    } else {
      id = seg[0];
    }
    console.log(`id: ${id}`);
    return id;
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/services/share.service.ts